// Modal style modifiers
export const MODAL_KIND_MODIFIERS = {
  default: '',
  danger: 'd-modal--danger',
};

// Modal size modifiers
export const MODAL_SIZE_MODIFIERS = {
  default: '',
  full: 'd-modal--full',
};

export const MODAL_BANNER_KINDS = {
  error: 'd-modal__banner--critical',
  info: 'd-modal__banner--info',
  success: 'd-modal__banner--success',
  warning: 'd-modal__banner--warning',
  base: 'd-modal__banner--general',
};
